import hoodieSizing from 'public/assets/images/hoodieSizing.webp';
import zipUpSizing from 'public/assets/images/zipUpSizing.png';
import tshirtSizing from 'public/assets/images/tshirtSizing.png';
import longSleeveTshirtSizing from 'public/assets/images/longSleeveTshirtSizing.webp';
import jeansSizing from 'public/assets/images/jeansSizing.png';
import jacketSizing from 'public/assets/images/jacketSizing.webp';
import mensTankTopSizing from 'public/assets/images/mensTankSizing.webp';
import womensTankTopSizing from 'public/assets/images/womensTankSizing.webp';
import sweatpantsSizing from 'public/assets/images/sweatpantsSizing.webp';
import wideSweatpantsSizing from 'public/assets/images/wideSweatpantsSizing.png';
import techJacketSizing from 'public/assets/images/techJacketSizing.webp';
import techPantsSizing from 'public/assets/images/techPantsSizing.webp';
import cargoPantsSizing from 'public/assets/images/cargoPantsSizing.webp';
import foldoverBeanie from 'public/assets/images/foldover_beanie.png';
import starCamoBeanie from 'public/assets/images/star_camo_beanie.png';
import polarFleeceSizing from 'public/assets/images/polar_fleece.png';
import croppedZipupSizing from 'public/assets/images/cropped_zipup.png';
import knitwearSizing from 'public/assets/images/knitwearSizing.png';
import workwearSizing from 'public/assets/images/workwearSizing.webp';
import versityJacketsSizing from 'public/assets/images/varsityJacket.png';
import denimShortsImage from 'public/assets/images/denimShorts.png';
import denimCorsetTopSizing from 'public/assets/images/denimCorsetTop.webp';
import pleatedSkirtSizing from 'public/assets/images/pleatedSkirt.webp';
import ripstopSkirt from 'public/assets/images/ripstopSkirt.webp';
import raglanLongSleeveTShirt from 'public/assets/images/raglanLongSleeveTShirt.webp';
import mensZipKnit from 'public/assets/images/mensZipKnit.webp';
import womensZipKnit from 'public/assets/images/womensZipKnit.webp';
import { buildRows } from '~/lib/sizing';
import sweatSorts from 'public/assets/images/sweatSorts.webp';
import bikini from 'public/assets/images/bikini.webp';
import slinkySkirt from 'public/assets/images/slinky_skirt.webp';
import straightLegSweatpants from 'public/assets/images/straight_leg_sweatpants.png';
import halterTop from 'public/assets/images/halter_top.webp';
import footballMeshShorts from 'public/assets/images/american_football_shorts.webp';
import buttonUpShirt from 'public/assets/images/button_up_shirt.webp';
import footballJersey from 'public/assets/images/football_jersey.webp';
import performanceTShirt from 'public/assets/images/performance_t_shirt.webp';
import trackPants from 'public/assets/images/track_pants.png';
import trackTop from 'public/assets/images/track_top.webp';
import sweatSkirt from 'public/assets/images/sweatSkirt.webp';
import croppedBoxyTshirt from 'public/assets/images/boxy_tshirt.webp';
import loungeCorset from 'public/assets/images/corset.webp';
import swimmingShorts from 'public/assets/images/swimming_shorts.webp';
import womensShorts from 'public/assets/images/women_shorts.webp';
import wideLegDenim from 'public/assets/images/wide-leg-jeans_1.webp';
import waffleLongSleeve from 'public/assets/images/waffle-long-sleeve.webp';
import racerJacket from 'public/assets/images/racer-jacket.webp';
import womensFootballJersey from 'public/assets/images/womens-football-jersey_1.webp';
import cuffedSweatpants from 'public/assets/images/cuffed_sweatpants.png';
import layeredTShirt from 'public/assets/images/layered_t_shirt.png';
import lightweightTank from 'public/assets/images/lightweight_tank.png';
import oneShoulderTop from 'public/assets/images/one_shoulder_top.png';
import newPolarFleece from 'public/assets/images/new_polar_fleece.png';
import velourJacket from 'public/assets/images/velour_jacket.png';
import velourTrackPants from 'public/assets/images/velour_track_pants.png';
import pufferSizing from 'public/assets/images/puffer.png';
import fauxFurZipUpHoodieImg from 'public/assets/images/FAUX_FUR_ZIP_UP_HOODIE.png';
import boxers from 'public/assets/images/boxers.png';
import topLeagueTrackJacket from 'public/assets/images/top_league_track_jacket.png';
import velourPants from 'public/assets/images/velour_pants.png';
import topLeagueTrackPants from 'public/assets/images/top_league_track_pants.png';
import workwearJacket from 'public/assets/images/workwearJacket.png';
import racerKnit from 'public/assets/images/racerKnit.png';
import pixelStarBeanie from 'public/assets/images/pixelStarBeanie.png';
import camoCargosImg from 'public/assets/images/CAMO_CARGOS.png';
import ShortsImage from 'public/assets/images/SHORTS.png';
import LightWeightTankImage from 'public/assets/images/LIGHT_WEIGHT_TANK.png';
import jerseyImage from 'public/assets/images/jersey.png';
import meshShortsImage from 'public/assets/images/mesh_shorts.png';
import cottonTrackTopImage from 'public/assets/images/cotton_track_top.png';
import babyTeeImage from 'public/assets/images/babyTee.png';
import beanieSizingImage from 'public/assets/images/beanieSizing.png';

import {
  hoodieSizes,
  tshirtSizes,
  zipUpSizes,
  babyTeeSizes,
  longSleeveTshirtSizes,
  sweatpantsSizes,
  wideSweatpantsSizes,
  womensTankTopSizes,
  mensTankTopSizes,
  jacketSizes,
  techJacketSizes,
  techPantsSizes,
  cargoSizes,
  polarFleeceSizes,
  croppedZipupSizes,
  workwearSizes,
  knitJacketSizes,
  varsityJacketSizes,
  denimShortsSizes,
  denimJeansSizes,
  denimCorsetSizing,
  denimSkirtSizing,
  ripstopSkirtSizes,
  thermalLongSleeveSizes,
  mensWashedRibbedZipUpSizes,
  womensWashedRibbedZipUpSizes,
  sweatShortsSizing,
  bikiniSizes,
  footballMeshShortsSizes,
  halterTopSizes,
  straightLegSweatpantsSizes,
  slinkySkirtSizes,
  buttonUpShirtSizes,
  footballJerseySizes,
  trackPantsSizes,
  trackTopSizes,
  performanceTShirtSizes,
  sweatSkirtSizes,
  croppedBoxyTshirtSizes,
  loungeCorsetSizes,
  womensShortsSizes,
  swimmingShortsSizes,
  wideLegDenimSizes,
  racerJacketSizes,
  womensFootballJerseySizes,
  longSleeveWaffleSizes,
  cuffedSweatpantsSizes,
  newHoodieShapeSizes,
  meshLayeredTShirtSizes,
  velourTrackJacketSizes,
  velourSweatpantsSizes,
  lightweightTankSizes,
  womensOneShoulderTopSizes,
  newPolarFleeceSizes,
  foldoverBeanieSizes,
  starCamoBeanieSizes,
  pufferSizes,
  fauxFurZipUpHoodieSizes,
  boxersSizes,
  topLeagueTrackJacketSizes,
  velourTrackPantsSizes,
  topLeagueTrackPantsSizes,
  workwearJacketSizes,
  racerKnitSizes,
  pixelStarBeanieSizes,
  shortSizes,
  jerseySizes,
  meshShortsSizes,
  cottonTrackTopSizes,
  waffleBeanieSizes,
} from './sizing';
import { ProductType } from '~/types/product';

export interface ProductSizing {
  title: string;
  sizing: (string | number)[][];
  img: string;
  type: ProductType[];
  imgStyle?: Record<string, string>;
}

//this is used in the product page size guide
export const productSizings: ProductSizing[] = [
  {
    title: 'Puffer',
    sizing: buildRows(pufferSizes),
    img: pufferSizing,
    type: [ProductType.Puffer],
  },
  {
    title: 'wide leg jeans',
    sizing: buildRows(wideLegDenimSizes),
    img: wideLegDenim,
    type: [ProductType.WideLegDenim],
  },
  {
    title: 'shorts',
    sizing: buildRows(shortSizes),
    img: ShortsImage,
    type: [ProductType.Shorts],
  },
  {
    title: 'racer jacket',
    sizing: buildRows(racerJacketSizes),
    img: racerJacket,
    type: [ProductType.RacerJacket],
  },
  {
    title: 'long sleeve waffle',
    sizing: buildRows(longSleeveWaffleSizes),
    img: waffleLongSleeve,
    type: [ProductType.LongSleeveWaffle],
  },
  {
    title: 'womens football jersey',
    sizing: buildRows(womensFootballJerseySizes),
    img: womensFootballJersey,
    type: [ProductType.WomensFootballJersey],
  },
  {
    title: 'swimming shorts',
    sizing: buildRows(swimmingShortsSizes),
    img: swimmingShorts,
    type: [ProductType.SwimmingShorts],
  },
  {
    title: 'womens shorts',
    sizing: buildRows(womensShortsSizes),
    img: womensShorts,
    type: [ProductType.WomensShorts],
  },
  {
    title: 'cropped boxy t-shirt',
    sizing: buildRows(croppedBoxyTshirtSizes),
    img: croppedBoxyTshirt,
    type: [ProductType.CroppedBoxyTShirt],
  },
  {
    title: 'lounge corset',
    sizing: buildRows(loungeCorsetSizes),
    img: loungeCorset,
    type: [ProductType.LoungeCorset],
  },
  {
    title: 'track top',
    sizing: buildRows(trackTopSizes),
    img: trackTop,
    type: [ProductType.TrackTop],
  },
  {
    title: 'track pants',
    sizing: buildRows(trackPantsSizes),
    img: trackPants,
    type: [ProductType.TrackPants],
  },
  {
    title: 'football jersey',
    sizing: buildRows(footballJerseySizes),
    img: footballJersey,
    type: [ProductType.FootballJersey],
  },
  {
    title: 'performance t-shirt',
    sizing: buildRows(performanceTShirtSizes),
    img: performanceTShirt,
    type: [ProductType.PerformanceTShirt],
  },
  {
    title: 'sweat shorts',
    sizing: buildRows(sweatShortsSizing),
    img: sweatSorts,
    type: [ProductType.SweatShorts],
  },
  {
    title: 'sweat skirt',
    sizing: buildRows(sweatSkirtSizes),
    img: sweatSkirt,
    type: [ProductType.SweatSkirt],
  },
  {
    title: 'hoodie',
    sizing: buildRows(newHoodieShapeSizes),
    img: hoodieSizing,
    type: [ProductType.Hoodie, ProductType.Crewneck],
  },
  {
    title: 'wide-leg sweatpants',
    sizing: buildRows(wideSweatpantsSizes),
    img: wideSweatpantsSizing,
    type: [ProductType.WideSweatpants],
  },
  {
    title: 'denim jeans',
    sizing: buildRows(denimJeansSizes),
    img: jeansSizing,
    type: [ProductType.DenimJeans],
  },
  {
    title: 'denim shorts',
    sizing: buildRows(denimShortsSizes),
    img: denimShortsImage,
    type: [ProductType.DenimShorts],
  },
  {
    title: 'camo thermal long-sleeve',
    sizing: buildRows(thermalLongSleeveSizes),
    img: raglanLongSleeveTShirt,
    type: [ProductType.CamoThermallongSleeve],
  },
  {
    title: 'cargo pants',
    sizing: buildRows(cargoSizes),
    img: camoCargosImg,
    type: [ProductType.CargoPants],
    imgStyle: { height: '270', my: '48' },
  },
  {
    title: 'denim corset top',
    sizing: buildRows(denimCorsetSizing),
    img: denimCorsetTopSizing,
    type: [ProductType.DenimCorsetTop],
  },
  {
    title: 'denim skirt',
    sizing: buildRows(denimSkirtSizing),
    img: pleatedSkirtSizing,
    type: [ProductType.DenimSkirt],
  },
  {
    title: 'ripstop camo skirt',
    sizing: buildRows(ripstopSkirtSizes),
    img: ripstopSkirt,
    type: [ProductType.RipstopCamoSkirt],
  },
  {
    title: 'bikini',
    sizing: buildRows(bikiniSizes),
    img: bikini,
    type: [ProductType.CamoBikini],
  },
  {
    title: 'zip-up',
    sizing: buildRows(zipUpSizes),
    img: zipUpSizing,
    type: [ProductType.ZipUp],
  },
  {
    title: 't-shirt',
    sizing: buildRows(tshirtSizes),
    img: tshirtSizing,
    type: [ProductType.TShirt],
  },

  {
    title: 'mens washed ribbed zip-up',
    sizing: buildRows(mensWashedRibbedZipUpSizes),
    img: mensZipKnit,
    type: [ProductType.MensWashedRibbedZipUp],
  },
  {
    title: 'womens washed ribbed zip-up',
    sizing: buildRows(womensWashedRibbedZipUpSizes),
    img: womensZipKnit,
    type: [ProductType.WomensWhashedRibbedZipUp],
  },
  {
    title: 'polar fleece',
    sizing: buildRows(polarFleeceSizes),
    img: polarFleeceSizing,
    type: [ProductType.PolarFleece],
  },
  {
    title: 'knitwear',
    sizing: buildRows(knitJacketSizes),
    img: knitwearSizing,
    type: [ProductType.Knitwear],
  },
  {
    title: 'straight-leg sweatpants',
    sizing: buildRows(sweatpantsSizes),
    img: sweatpantsSizing,
    type: [ProductType.Sweatpants],
  },
  {
    title: 'stargirl tee',
    sizing: buildRows(babyTeeSizes),
    img: babyTeeImage,
    type: [ProductType.BabyTee],
  },
  // {
  //   title: 'baby tee',
  //   sizing: buildRows(babyTeeSizes),
  //   img: babyTeeImage,
  //   type: [ProductType.BabyTee],
  // },
  {
    title: "men's tank-tops",
    sizing: buildRows(mensTankTopSizes),
    img: mensTankTopSizing,
    type: [ProductType.MensTankTop, ProductType.RibbedTankTopSizes],
  },
  {
    title: "ribbed women's tank-tops",
    sizing: buildRows(womensTankTopSizes),
    img: womensTankTopSizing,
    type: [ProductType.WomensTankTop, ProductType.RibbedTankTopSizesWoman],
  },
  {
    title: 'cropped zip-ups',
    sizing: buildRows(croppedZipupSizes),
    img: croppedZipupSizing,
    type: [ProductType.CroppedZipUp],
  },
  {
    title: 'Varsity jacket',
    sizing: buildRows(varsityJacketSizes),
    img: versityJacketsSizing,
    type: [ProductType.VarsityJacket],
  },

  {
    title: 'denim workwear jacket',
    sizing: buildRows(workwearSizes),
    img: workwearSizing,
    type: [ProductType.DenimWorkwearJacket],
  },
  {
    title: 'workwear jacket',
    sizing: buildRows(workwearJacketSizes),
    img: workwearJacket,
    type: [ProductType.WorkwearJacket],
  },

  {
    title: 'Star Camo Beanie',
    sizing: buildRows(starCamoBeanieSizes),
    img: starCamoBeanie,
    type: [ProductType.StarCamoBeanie],
  },
  {
    title: 'Foldover beanie',
    sizing: buildRows(foldoverBeanieSizes),
    img: foldoverBeanie,
    type: [ProductType.FoldoverBeanie],
  },
  {
    title: 'long sleeve t-shirt',
    sizing: buildRows(longSleeveTshirtSizes),
    img: longSleeveTshirtSizing,
    type: [ProductType.LongSleeve],
  },
  {
    title: 'denim jacket',
    sizing: buildRows(jacketSizes),
    img: jacketSizing,
    type: [ProductType.DenimJacket],
  },
  {
    title: 'waterproof tech-jacket',
    sizing: buildRows(techJacketSizes),
    img: techJacketSizing,
    type: [ProductType.TechJacket],
  },
  {
    title: 'waterproof tech-pants',
    sizing: buildRows(techPantsSizes),
    img: techPantsSizing,
    type: [ProductType.TechPants],
  },
  {
    title: 'football mesh shorts',
    sizing: buildRows(footballMeshShortsSizes),
    img: footballMeshShorts,
    type: [ProductType.FootballMeshShorts],
  },
  {
    title: "women's halter top",
    sizing: buildRows(halterTopSizes),
    img: halterTop,
    type: [ProductType.HalterTop],
  },
  {
    title: 'straight leg sweatpants',
    sizing: buildRows(straightLegSweatpantsSizes),
    img: straightLegSweatpants,
    type: [ProductType.StraightLegSweatpants],
  },
  {
    title: 'pleated skirt',
    sizing: buildRows(slinkySkirtSizes),
    img: slinkySkirt,
    type: [ProductType.SlinkySkirt],
  },
  {
    title: 'button up shirt',
    sizing: buildRows(buttonUpShirtSizes),
    img: buttonUpShirt,
    type: [ProductType.ButtonUpShirt],
  },
  {
    title: 'new hoodie shape',
    sizing: buildRows(newHoodieShapeSizes),
    img: hoodieSizing,
    type: [ProductType.NewHoodieShape],
  },
  {
    title: 'cuffed sweatpants',
    sizing: buildRows(cuffedSweatpantsSizes),
    img: cuffedSweatpants,
    type: [ProductType.CuffedSweatpants],
  },
  {
    title: 'mesh layered t-shirt',
    sizing: buildRows(meshLayeredTShirtSizes),
    img: layeredTShirt,
    type: [ProductType.MeshLayeredTShirt],
  },
  {
    title: 'velour track jacket',
    sizing: buildRows(velourTrackJacketSizes),
    img: velourJacket,
    type: [ProductType.VelourTrackJacket],
  },
  {
    title: 'velour sweatpants',
    sizing: buildRows(velourSweatpantsSizes),
    img: velourTrackPants,
    type: [ProductType.VelourSweatpants],
  },
  {
    title: 'velour track pants',
    sizing: buildRows(velourTrackPantsSizes),
    img: velourPants,
    type: [ProductType.VelourTrackPants],
  },
  {
    title: "men's ribbed tank top",
    sizing: buildRows(lightweightTankSizes),
    img: LightWeightTankImage,
    type: [ProductType.LightWeightTank],
  },
  {
    title: 'womens one shoulder top',
    sizing: buildRows(womensOneShoulderTopSizes),
    img: oneShoulderTop,
    type: [ProductType.WomensOneShoulderTop],
  },
  {
    title: 'new polar fleece',
    sizing: buildRows(newPolarFleeceSizes),
    img: newPolarFleece,
    type: [ProductType.NewPolarFleece],
  },
  {
    title: 'faux fur zip up hoodie',
    sizing: buildRows(fauxFurZipUpHoodieSizes),
    img: fauxFurZipUpHoodieImg,
    type: [ProductType.FauxFurZipUpHoodie],
  },
  {
    title: 'boxers',
    sizing: buildRows(boxersSizes),
    img: boxers,
    type: [ProductType.Boxers],
  },
  {
    title: 'top league track jacket',
    sizing: buildRows(topLeagueTrackJacketSizes),
    img: topLeagueTrackJacket,
    type: [ProductType.TopLeagueTrackJacket],
  },
  {
    title: 'top league track pants',
    sizing: buildRows(topLeagueTrackPantsSizes),
    img: topLeagueTrackPants,
    type: [ProductType.TopLeagueTrackPants],
  },
  {
    title: 'racer knit',
    sizing: buildRows(racerKnitSizes),
    img: racerKnit,
    type: [ProductType.RacerKnit],
  },
  {
    title: 'pixer star beanie',
    sizing: buildRows(pixelStarBeanieSizes),
    img: pixelStarBeanie,
    type: [ProductType.PixelStarBeanie],
  },
  {
    title: 'allstars jersey',
    sizing: buildRows(jerseySizes),
    img: jerseyImage,
    type: [ProductType.Jersey],
  },
  {
    title: 'mesh shorts',
    sizing: buildRows(meshShortsSizes),
    img: meshShortsImage,
    type: [ProductType.MeshShorts],
  },
  {
    title: 'cotton track zip-up',
    sizing: buildRows(cottonTrackTopSizes),
    img: cottonTrackTopImage,
    type: [ProductType.CottonTrackTop],
  },
  {
    title: 'waffle beanie',
    sizing: buildRows(waffleBeanieSizes),
    img: beanieSizingImage,
    type: [ProductType.WaffleBeanie],
  },
];
